// Thresholds for the Case Chat client. Every number the engine, the poll
// protocol and the paint throttle depend on lives here so the tests pin both
// sides of each boundary against one definition.

/** Message limit, counted in code points. The server enforces the same number. */
export const MAX_TEXT = 50_000;

/** Server long-poll hold per mode (seconds). The server clamps `wait` to 20. */
export const HOLD_RESUME_S = 1;
export const HOLD_HIDDEN_S = 15;
export const HOLD_AFTER_EVENTS_S = 10;
export const HOLD_DEFAULT_S = 5;

/** Lambda cold start plus API Gateway can legitimately add seconds. */
export const POLL_SLACK_MS = 6_000;
/** The page gives up on an overdue poll this much later. */
export const POLL_GIVE_UP_AFTER_DUE_MS = 1_000;

export const BACKOFF_BASE_MS = 500;
export const BACKOFF_MAX_MS = 5_000;
/** A throttled (429) poll waits at least this long. */
export const THROTTLE_MIN_WAIT_MS = 5_000;

/** The "Reconnecting" note appears this long after the first failed poll. */
export const RECONNECT_NOTE_MS = 10_000;

/** Minimum time between poll starts while a poll returned events. */
export const STREAM_GAP_MS = 250;
/** An empty poll that returned faster than this waits EMPTY_POLL_WAIT_MS. */
export const FAST_EMPTY_POLL_MS = 300;
export const EMPTY_POLL_WAIT_MS = 400;

/** A real status phrase stays on screen at least this long. */
export const STATUS_HOLD_MS = 1_200;

/** Live text repaint: at most 4 a second, widened when a paint is slow. */
export const PAINT_GAP_MS = 250;
export const PAINT_COST_FACTOR = 5;

/** Within this many pixels of the bottom the thread follows new text. */
export const STICK_PX = 80;

/**
 * A single request (send, transcript read, Stop) that has not answered in this long is cut off and
 * treated as a transient failure. The events poll has its own, longer, watchdog. Paused while the
 * re-login modal is open.
 */
export const REQUEST_TIMEOUT_MS = 35_000;

/** The loop survives this many unexpected crashes, napping between them. */
export const LOOP_CRASH_LIMIT = 5;
export const LOOP_CRASH_NAP_MS = 2_000;

/** Silent retries of a send that failed in transit (same client_turn_id). */
export const SEND_RETRY_DELAYS_MS: readonly number[] = [500, 1_000, 2_000];

export const VISIBLE_REFETCH_AFTER_MS = 30_000;
export const LIST_REFRESH_WHILE_RUNNING_MS = 20_000;
export const AVAILABILITY_TTL_MS = 60_000;

export const STATUS_CLIP = 200;
export const COPIED_FLASH_MS = 1_800;
export const DRAFT_WRITE_DEBOUNCE_MS = 400;
export const TITLE_MAX = 40;

/** Client reports: at most this many per window. */
export const REPORT_LIMIT = 4;
export const REPORT_WINDOW_MS = 60_000;
export const REPORT_DETAIL_MAX = 200;
